import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "5",
      height: "5",
      x: "3",
      y: "3",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "5",
      height: "5",
      x: "16",
      y: "3",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "5",
      height: "5",
      x: "3",
      y: "16",
      rx: "1"
    }, null, -1),
    _createElementVNode("path", { d: "M21 16h-3a2 2 0 0 0-2 2v3M21 21v.01M12 7v3a2 2 0 0 1-2 2H7M3 12h.01M12 3h.01M12 16v.01M16 12h1M21 12v.01M12 21v-1" }, null, -1)
  ]))]))
}
export default { render: render }